<template lang="pug">
include /mixins

div
  +b.g-row
    +b.g-cell.g-cols--12
      slot(name='auth-btn')
  +b.g-row
    +b.g-cell.g-cols--12.tt-space_mt--8
      phone-input(
        :rules="'required|phone'"
        :input-label='labels.phone'
        :value='phone'
        ref='phone'
        name='phone'
        :disabled='false'
        @input='$emit("update:phone", $event)'
      )
    +b.g-cell.g-cols.tt-space_mt--6
      +b.ds-caption.--size_sm.--medium.--color_black.P {{ _('Нажимая кнопку "Далее" вы соглашаетесь с') }} &nbsp;
        +b.tt-link--inline.--styling_default.--black.A.ds-caption--size_sm.--medium(:href='offer', target='_blank') {{ _('политикой конфиденциальности') }}
        span &nbsp; {{ _('и') }} &nbsp;
        +b.tt-link--inline.--styling_default.--black.A.ds-caption--size_sm.--medium(:href='rules', target='_blank') {{ _('правилами пользования TOTIS Pharma') }}
</template>

<script>
export default {
  name: 'StepPhone',
  props: {
    phone: { type: String, default: '' },
    offer: { type: String, default: '' },
    rules: { type: String, default: '' },
    labels: { type: Object, default: () => ({}) },
  },
}
</script>
